import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../../components/layout/layout';
import TeamsComponent from '../../components/TeamsComponent/TeamsComponent';
import API from '../../utils/API';
import styles from './teams.module.scss';
import Preloader from '../../components/Preloader/Preloader';
import { useTranslation } from 'react-i18next';
import { HandleError, handleRedirect } from '../../utils/helpers';
import { useHistory } from 'react-router-dom';
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent';
import { sendAmplitudeData } from '../../utils/amplitude';
import dayjs from 'dayjs';

export default function Teams(props) {
  const [data, setData] = useState(null);
  const [lastUpdateDate, setLastUpdateDate] = useState('');
  const [image, setImage] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentPanel, setCurrentPanel] = useState();

  let history = useHistory();

  const { t, i18n } = useTranslation();

  useEffect(() => {
    console.log(`event: open /ui/teams"`);
    sendAmplitudeData(`screen shown "Teams"`);
    fetchData();
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await API.get('/teams/');
      if (response.status === 200) {
        handleRedirect(response, history);
        setData(response.data);
        setLastUpdateDate(response.data.last_update);
        setImage(response.data.club.icon);
        if (props.user === '') {
          props.setUser(response.data.user);
        }
      }
      setLoading(false);
      window.scrollTo(0, 0);
    } catch (e) {
      setLoading(false);
      if (e.response && e.response.status) {
        HandleError(e, history);
      }
      console.log('Error fetch teams data: ', e);
    }
  }, [setData, setLastUpdateDate, setImage, setLoading]);

  return (
    <Layout isSidebarCollapsed={props.isSidebarCollapsed} changeCollapseSidebar={props.changeCollapseSidebar} user={props.user}>
      {/*<Head>*/}
      {/*    <title>Teams</title>*/}
      {/*    <meta name="viewport" content="initial-scale=1.0, width=device-width"/>*/}
      {/*</Head>*/}
      {loading ? (
        <Preloader />
      ) : (
        <div className={styles.teamsContainer}>
          <HeaderComponent isSidebarCollapsed={props.isSidebarCollapsed} title={t('Teams')} lastUpdateDate={lastUpdateDate} lastUpdateTitle={'last-updated'} image={image} />

          <div className={styles.teams}>
            <TeamsComponent {...data} fetchData={fetchData} isSidebarCollapsed={props.isSidebarCollapsed} currentPanel={currentPanel} setCurrentPanel={setCurrentPanel} />
          </div>
        </div>
      )}
    </Layout>
  );
}
